var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 353,
    viewBox: "0 0 369 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_3920)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0989 356.317C58.1084 352.924 56.464 347.819 53.8846 341.808C52.5455 338.688 51.4737 336.533 48.6703 331.02C38.8912 311.787 37.9959 310.592 38.614 307.955C39.9331 302.328 46.2712 298.128 51.6499 294.562C56.5775 291.296 58.6882 291.241 59.8438 288.61C61.694 284.398 57.6258 281.482 55.002 272.242C52.869 264.73 53.1801 258.285 53.5121 251.409C53.8491 244.428 54.9659 238.831 55.3743 236.9C57.2836 227.87 59.1284 226.029 59.0989 219.787C59.0721 214.12 57.5228 209.709 56.8642 207.883C55.5357 204.199 54.4431 203.011 49.0426 193.002C47.1499 189.495 46.2037 187.741 45.6905 186.678C43.6514 182.455 39.5288 173.711 38.9865 162.497C38.7659 157.935 38.6556 155.654 39.7314 152.825C41.0715 149.301 43.0731 147.857 47.1804 142.036C49.6045 138.601 50.8054 136.876 51.2774 135.712C53.9626 129.09 51.3164 122.145 50.5325 120.087C46.9928 110.798 41.3987 110.703 39.359 103.719C37.9777 98.9889 39.4652 95.3397 42.711 86.6061C53.9219 56.4402 54.5209 50.6116 59.4712 49.7767C65.4075 48.7755 74.1631 55.5356 75.859 56.845C79.2264 59.445 80.6917 61.5545 83.6805 61.6811C88.3895 61.8807 92.1434 56.958 93.3643 55.3569C99.5055 47.3034 96.0706 41.7552 100.068 34.5241C104.452 26.5948 113.676 24.0531 124.278 21.1316C131.665 19.0957 142.622 16.0764 154.446 20.0155C166.972 24.1885 170.134 32.7275 179.773 31.5479C182.859 31.1703 185.927 29.4361 192.064 25.9677C201.409 20.6861 203.134 17.3801 208.824 16.2953C213.044 15.4906 215.418 16.6762 222.232 18.5274C235.254 22.0653 233.498 19.6135 258.732 24.4797C258.732 24.4797 266.877 26.0505 277.727 27.8278C283.496 28.7729 284.59 28.8853 285.921 28.9438C294.648 29.3276 296.053 26.6224 304.543 25.9677C308.417 25.6691 306.789 26.335 325.773 28.9438C327.384 29.1652 329.779 29.4879 332.105 31.1759C335.2 33.4221 334.717 35.5788 336.947 37.8722C339.567 40.5675 342.874 40.3052 354.7 40.9723C354.7 40.9723 360.284 41.2874 365.625 41.7164C373.456 42.3453 380.298 114.808 381.02 371.818",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0989 356.317C58.1084 352.924 56.464 347.819 53.8846 341.808C52.5455 338.688 51.4737 336.533 48.6703 331.02C38.8912 311.787 37.9959 310.592 38.614 307.955C39.9331 302.328 46.2712 298.128 51.6499 294.562C56.5775 291.296 58.6882 291.241 59.8438 288.61C61.694 284.398 57.6258 281.482 55.002 272.242C52.869 264.73 53.1801 258.285 53.5121 251.409C53.8491 244.428 54.9659 238.831 55.3743 236.9C57.2836 227.87 59.1284 226.029 59.0989 219.787C59.0721 214.12 57.5228 209.709 56.8642 207.883C55.5357 204.199 54.4431 203.011 49.0426 193.002C47.1499 189.495 46.2037 187.741 45.6905 186.678C43.6514 182.455 39.5288 173.711 38.9865 162.497C38.7659 157.935 38.6556 155.654 39.7314 152.825C41.0715 149.301 43.0731 147.857 47.1804 142.036C49.6045 138.601 50.8054 136.876 51.2774 135.712C53.9626 129.09 51.3164 122.145 50.5325 120.087C46.9928 110.798 41.3987 110.703 39.359 103.719C37.9777 98.9889 39.4652 95.3397 42.711 86.6061C53.9219 56.4402 54.5209 50.6116 59.4712 49.7767C65.4075 48.7755 74.1631 55.5356 75.859 56.845C79.2264 59.445 80.6917 61.5545 83.6806 61.6811C88.3895 61.8807 92.1434 56.958 93.3643 55.3569C99.5055 47.3034 96.0706 41.7552 100.068 34.5241C104.452 26.5948 113.676 24.0531 124.278 21.1316C131.665 19.0957 142.622 16.0764 154.446 20.0155C166.972 24.1885 170.134 32.7275 179.773 31.5479C182.859 31.1703 185.927 29.4361 192.064 25.9677C201.409 20.6861 203.134 17.3801 208.824 16.2953C213.044 15.4906 215.418 16.6762 222.232 18.5274C235.254 22.0653 233.498 19.6135 258.732 24.4797C258.732 24.4797 266.877 26.0505 277.727 27.8278C283.496 28.7729 284.59 28.8853 285.921 28.9438C294.649 29.3276 296.053 26.6224 304.543 25.9677C308.417 25.6691 306.789 26.335 325.773 28.9438C327.384 29.1652 329.779 29.4879 332.105 31.1759C335.2 33.4221 334.717 35.5788 336.947 37.8722C339.567 40.5675 342.874 40.3052 354.7 40.9723C354.7 40.9723 360.284 41.2874 365.625 41.7164C373.456 42.3453 380.298 114.808 381.02 371.818",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M360.587 7.62549H8.41406V344.173H360.587V7.62549Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5147 358.158C83.3022 357.216 82.7094 351.571 79.0582 345.309C75.4512 339.122 72.6257 338.791 71.1357 333.942C69.2118 327.681 71.8629 321.53 73.1164 318.622C75.1542 313.894 76.3128 314.616 81.534 305.773C85.057 299.805 86.0245 296.944 86.4856 295.394C87.7161 291.258 87.872 287.953 87.9711 285.51C88.1897 280.125 88.4736 273.13 85.0002 266.731C82.1852 261.544 80.2741 262.962 75.5922 256.847C73.375 253.951 67.2461 245.946 68.1648 236.585C68.4969 233.2 69.7335 229.807 72.1262 223.241C74.0072 218.079 74.39 218.178 74.6019 216.322C75.4318 209.061 69.6557 206.798 70.6406 201.002C71.3215 196.996 74.1885 197.446 77.0777 190.624C78.1062 188.195 79.3515 185.255 79.0582 181.728C78.8297 178.98 77.7323 176.659 73.1164 170.856C65.069 160.738 62.7325 160.66 60.7376 155.535C60.0795 153.845 58.0739 148.692 59.7472 143.18C61.7038 136.735 66.7969 136.037 66.6794 131.814C66.5312 126.487 58.3629 125.226 58.2618 119.459C58.218 116.961 59.7445 116.841 62.223 110.563C64.0057 106.048 64.897 103.791 64.6988 101.668C64.0543 94.7669 55.4288 93.1857 55.2907 87.3357C55.2165 84.1881 57.6268 80.9618 60.2423 79.4285C68.4551 74.6141 77.6271 87.1167 89.9518 83.8763C96.5206 82.1493 100.523 76.8604 103.816 72.5097C110.23 64.0354 113.426 52.2027 114.214 49.2822C115.917 42.9784 115.763 40.7528 117.68 39.8924C123.793 37.1499 136.108 54.9361 139.467 52.7416C140.759 51.898 139.153 49.1295 139.467 43.3518C139.649 40.014 140.089 31.9463 145.409 28.0316C150.497 24.2885 158.84 25.2293 163.73 29.02C167.672 32.076 166.335 34.632 172.643 44.3402C178.241 52.9559 181.06 53.6589 182.546 53.73C185.114 53.8529 187.095 52.2522 189.478 50.2706C196.305 44.5955 194.884 40.8406 199.381 37.4214C202.187 35.2881 203.051 36.513 221.168 34.4562C225.823 33.9277 228.029 33.5899 232.062 33.4678C243.336 33.1262 246.023 35.1618 246.916 35.9388C249.778 38.4271 248.762 40.6237 251.373 42.3634C255.023 44.7962 258.676 41.6115 265.732 40.8808C276.8 39.7347 277.779 46.5376 289.004 45.3286C294.264 44.7622 297.812 42.8636 302.869 44.8344C305.994 46.0524 305.551 47.1331 308.316 48.2938C315.111 51.1462 319.755 45.4451 329.112 46.317C331.867 46.5737 329.989 46.9303 339.51 49.7764C350.227 52.98 355.061 53.2621 359.317 52.7416C362.326 52.3736 363.575 51.7841 364.268 51.7532C378.078 51.1384 479.072 258.403 376.152 362.606C277.849 462.135 86.8843 373.109 83.5147 358.158Z",
    fill: "#9E1F63",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.889 356.087C182.356 351.297 188.098 343.555 188.791 333.501C189.489 323.397 184.407 320.802 185.818 313.426C188.258 300.671 204.604 302.413 218.031 285.32C228.352 272.181 222.512 266.29 233.394 255.206C238.682 249.82 239.457 251.826 263.624 238.142C275.764 231.268 279.284 228.658 287.412 226.097C288.762 225.671 291.631 224.381 295.643 223.699C300.6 222.856 307.898 221.615 311.696 225.093C316.76 229.731 313.745 241.099 311.696 249.184C309.034 259.687 305.011 265.284 306.74 266.75C308.716 268.425 313.392 260.621 323.59 259.222C331.424 258.146 336.696 261.65 341.926 257.716C342.745 257.1 343.628 255.967 345.395 253.701C350.875 246.674 350.889 243.786 353.82 241.655C353.82 241.655 358.449 238.29 365.714 240.652C372.258 242.778 377.638 263.023 364.723 358.596",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.889 356.087C182.356 351.297 188.098 343.555 188.791 333.501C189.489 323.397 184.407 320.802 185.818 313.426C188.258 300.671 204.604 302.413 218.031 285.32C228.352 272.181 222.512 266.29 233.394 255.206C238.682 249.82 239.457 251.826 263.624 238.142C275.764 231.268 279.284 228.658 287.412 226.097C288.762 225.671 291.631 224.381 295.643 223.699C300.6 222.856 307.898 221.615 311.696 225.093C316.76 229.731 313.745 241.099 311.696 249.184C309.034 259.687 305.011 265.284 306.74 266.75C308.716 268.425 313.392 260.621 323.59 259.222C331.424 258.146 336.696 261.65 341.926 257.716C342.745 257.1 343.628 255.967 345.395 253.701C350.875 246.674 350.889 243.786 353.82 241.655C353.82 241.655 358.449 238.29 365.714 240.652C372.258 242.778 377.638 263.023 364.723 358.596",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.233 356.736C189.882 354.727 189.157 349.002 192.386 343.548C194.167 340.541 196.419 338.851 197.851 337.799C202.577 334.326 207.356 333.626 210.271 333.234C213.792 332.76 216.298 333.005 220.372 333.403C226.702 334.021 230.558 334.398 234.945 336.446C240.933 339.243 240.513 341.7 246.371 343.717C250.27 345.059 253.633 345.065 256.639 345.07C261.966 345.078 264.825 345.083 267.237 343.21C270.197 340.911 269.023 338.474 271.874 332.727C272.919 330.619 276.13 324.143 282.472 320.891C286.479 318.836 287.91 320.031 293.898 317.002C296.674 315.598 297.001 315.02 300.025 313.62C302.678 312.393 305.553 311.062 309.465 310.577C311.416 310.335 315.886 309.832 320.725 311.761C325.221 313.552 325.661 315.699 328.674 315.649C330.404 315.621 330.8 314.905 336.126 311.761C340.191 309.361 342.223 308.162 344.903 307.195C348.07 306.053 347.454 306.867 352.852 305.335C356.856 304.2 358.835 303.286 362.291 303.306C363.855 303.316 365.313 303.513 365.768 303.645C372.59 305.607 366.593 353.46 365.934 358.596",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.233 356.736C189.882 354.727 189.157 349.002 192.386 343.548C194.167 340.541 196.419 338.851 197.851 337.799C202.577 334.326 207.356 333.626 210.271 333.234C213.792 332.76 216.298 333.005 220.372 333.403C226.702 334.021 230.558 334.398 234.945 336.446C240.933 339.243 240.513 341.7 246.371 343.717C250.27 345.059 253.633 345.065 256.639 345.07C261.966 345.078 264.825 345.083 267.237 343.21C270.197 340.911 269.023 338.474 271.874 332.727C272.919 330.619 276.13 324.143 282.472 320.891C286.479 318.836 287.91 320.031 293.898 317.002C296.674 315.598 297.001 315.02 300.025 313.62C302.678 312.393 305.553 311.062 309.465 310.577C311.416 310.335 315.886 309.832 320.725 311.761C325.221 313.552 325.661 315.699 328.674 315.649C330.404 315.621 330.8 314.905 336.126 311.761C340.191 309.361 342.223 308.162 344.903 307.195C348.07 306.053 347.454 306.867 352.852 305.335C356.856 304.2 358.835 303.286 362.291 303.306C363.855 303.316 365.313 303.513 365.768 303.645C372.59 305.607 366.593 353.46 365.934 358.596",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8131 355.787C87.5423 347.674 85.6184 341.227 84.3446 337.035C80.9218 325.772 79.4845 321.877 81.3618 317.297C82.6499 314.154 84.8719 312.405 89.316 308.908C89.316 308.908 93.2919 305.778 107.213 299.038C110.88 296.578 112.959 294.002 114.173 292.13C116.128 289.114 116.025 287.636 118.647 283.247C120.77 279.693 121.831 277.916 123.618 276.832C127.851 274.265 131.561 276.974 134.058 274.858C137.125 272.261 135.051 265.199 134.555 263.509C130.144 248.48 118.064 248.115 115.167 235.874C113.057 226.957 117.422 218.506 118.647 216.136C121.427 210.754 123.243 211.065 128.093 204.786C131.118 200.869 142.134 186.606 138.533 171.724C137.676 168.182 137.015 165.453 134.555 163.335C128.419 158.049 119.851 164.115 106.219 159.387C103.356 158.394 100.439 156.984 98.2644 155.933C91.6507 152.736 88.3439 151.137 87.8245 149.518C86.0281 143.916 99.019 130.742 113.676 129.285C119.387 128.718 120.784 130.384 132.07 129.779C138.664 129.426 143.547 128.57 147.978 125.338C149.21 124.439 151.303 122.913 152.452 120.896C158.659 110.015 132.69 93.1255 136.544 74.5105C137.924 67.8463 142.987 61.6283 148.972 59.7065C157.309 57.0297 166.292 63.0541 172.338 67.1085C172.338 67.1085 174.829 68.7792 187.749 80.4322C194.084 80.7544 202.645 80.0668 209.126 74.5105C211.763 72.2501 211.549 71.3327 214.595 68.0955C224.322 57.7562 237.864 55.0393 237.96 55.2653C238.038 55.4485 229.655 58.4308 230.006 59.7065C230.335 60.9033 237.877 58.8772 250.886 58.2261C263.55 57.5923 264.644 59.0998 274.251 57.7326C280.443 56.8514 281.607 55.9948 288.668 55.2653C297.188 54.3851 301.448 53.945 305.074 55.7588C313.43 59.939 315.745 72.4303 315.514 72.5367C315.344 72.6147 312.67 66.5496 312.531 66.6151C312.347 66.7014 314.528 78.4154 322.971 83.393C324.355 84.2088 323.891 83.6555 337.388 87.3407C346.719 89.8885 344.192 89.4026 347.828 90.3015C353.546 91.7153 355.644 91.8909 358.765 93.7558C360.971 95.0744 362.471 96.5105 364.233 98.197C364.233 98.197 367.587 101.407 370.199 105.106C393.265 137.77 379.147 222.551 379.147 222.551C373.597 255.885 368.813 302.362 371.69 362.202",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8131 355.787C87.5423 347.674 85.6184 341.227 84.3446 337.035C80.9218 325.772 79.4845 321.877 81.3618 317.297C82.6499 314.154 84.8719 312.405 89.316 308.908C89.316 308.908 93.2919 305.778 107.213 299.038C110.88 296.578 112.959 294.002 114.173 292.13C116.128 289.114 116.025 287.636 118.647 283.247C120.77 279.693 121.831 277.916 123.618 276.832C127.851 274.265 131.561 276.974 134.058 274.858C137.125 272.261 135.051 265.199 134.555 263.509C130.144 248.48 118.064 248.115 115.167 235.874C113.057 226.957 117.422 218.506 118.647 216.136C121.427 210.754 123.243 211.065 128.093 204.786C131.118 200.869 142.134 186.606 138.533 171.724C137.676 168.182 137.015 165.453 134.555 163.335C128.419 158.049 119.851 164.115 106.219 159.387C103.356 158.394 100.439 156.984 98.2644 155.933C91.6507 152.736 88.3439 151.137 87.8245 149.518C86.0281 143.916 99.019 130.742 113.676 129.285C119.387 128.718 120.784 130.384 132.07 129.779C138.664 129.426 143.547 128.57 147.978 125.338C149.21 124.439 151.303 122.913 152.452 120.896C158.659 110.015 132.69 93.1255 136.544 74.5105C137.924 67.8463 142.987 61.6283 148.972 59.7065C157.309 57.0297 166.292 63.0541 172.338 67.1085C172.338 67.1085 174.829 68.7792 187.749 80.4322C194.084 80.7544 202.645 80.0668 209.126 74.5105C211.763 72.2501 211.549 71.3327 214.595 68.0955C224.322 57.7562 237.864 55.0393 237.96 55.2653C238.038 55.4485 229.655 58.4308 230.006 59.7065C230.335 60.9033 237.877 58.8772 250.886 58.2261C263.55 57.5923 264.644 59.0998 274.251 57.7326C280.443 56.8514 281.607 55.9948 288.668 55.2653C297.188 54.3851 301.448 53.945 305.074 55.7588C313.43 59.939 315.745 72.4303 315.514 72.5367C315.344 72.6147 312.67 66.5496 312.531 66.6151C312.347 66.7014 314.528 78.4154 322.971 83.393C324.355 84.2088 323.891 83.6555 337.388 87.3407C346.719 89.8885 344.192 89.4026 347.828 90.3015C353.546 91.7153 355.644 91.8909 358.765 93.7558C360.971 95.0744 362.471 96.5105 364.233 98.197C364.233 98.197 367.587 101.407 370.199 105.106C393.265 137.77 379.147 222.551 379.147 222.551C373.597 255.885 368.813 302.362 371.69 362.202",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.852 354.876C140.943 349.062 140.009 345.911 139.34 344.541C138.438 342.692 136.905 341.802 129.417 338.143C120.807 333.935 118.89 333.185 118.998 332.237C119.233 330.176 128.636 330.543 137.852 325.346C139.054 324.668 140.9 323.531 142.317 321.409C144.286 318.46 144.267 315.35 144.301 313.534C144.463 305.049 146.146 306.829 146.782 295.324C147.198 287.802 146.441 287.737 146.782 277.114C146.979 270.99 147.091 267.865 147.775 264.81C149.44 257.363 152.574 252.685 154.72 249.552C157.385 245.662 158.757 243.716 160.674 243.646C164.301 243.515 168.162 249.731 169.605 255.458C172.375 266.458 165.169 271.465 167.124 285.973C167.676 290.068 168.674 292.813 169.605 295.324C171.147 299.483 173.63 306.181 176.551 306.152C178.535 306.132 179.475 303.017 182.504 297.293C187.318 288.195 188.47 289.399 192.923 281.051C197.929 271.669 200.438 266.965 198.877 261.857C198.211 259.677 197.591 260.001 191.435 251.029C188.551 246.827 187.109 244.725 185.977 242.662C183.304 237.789 180.258 232.237 180.52 225.436C180.768 218.969 183.895 214.283 185.977 211.163C191.492 202.899 195.278 204.418 199.373 197.383C202.536 191.947 204.191 184.315 202.846 177.204C201.752 171.418 199.489 170.293 200.365 166.868C201.477 162.523 205.751 161.865 214.257 156.041C221.009 151.417 225.461 146.939 228.645 143.736C232.176 140.185 234.968 136.611 240.553 129.463C247.33 120.789 250.773 116.348 253.452 111.253C255.064 108.188 257.596 103.305 259.406 96.4883C260.55 92.18 261.389 87.165 261.887 84.1841C263.459 74.7788 263.244 72.2668 265.36 70.8956C268.895 68.6044 274.936 72.0912 276.275 72.8642C287.225 79.1846 291.076 93.5416 290.167 94.0274C289.448 94.4116 284.566 86.7541 284.709 86.6449C284.854 86.5344 290.549 93.844 302.074 107.808C305.756 112.269 305.909 112.409 309.02 116.175C325.695 136.354 333.537 147.218 334.323 146.689C335.01 146.228 330.214 137.18 329.858 137.338C329.387 137.548 334.713 154.718 340.277 154.564C342.735 154.496 342.912 151.11 347.719 147.674C351.713 144.819 358.522 142.202 362.107 144.721C363.724 145.857 364.616 147.988 364.588 157.025C364.553 168.241 363.159 172.076 363.1 178.188C362.992 189.315 367.496 188.95 368.557 200.336C370.119 217.086 361.028 224.92 366.076 232.819C369.453 238.103 375.76 237.836 379.472 239.709C390.094 245.068 392.165 273.919 368.061 359.798",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.852 354.876C140.943 349.062 140.009 345.911 139.34 344.541C138.438 342.692 136.905 341.802 129.417 338.143C120.807 333.935 118.89 333.185 118.998 332.237C119.233 330.176 128.636 330.543 137.852 325.346C139.054 324.668 140.9 323.531 142.317 321.409C144.286 318.46 144.267 315.35 144.301 313.534C144.463 305.049 146.146 306.829 146.782 295.324C147.198 287.802 146.441 287.737 146.782 277.114C146.979 270.99 147.091 267.865 147.775 264.81C149.44 257.363 152.574 252.685 154.72 249.552C157.385 245.662 158.757 243.716 160.674 243.646C164.301 243.515 168.162 249.731 169.605 255.458C172.375 266.458 165.169 271.465 167.124 285.973C167.676 290.068 168.674 292.813 169.605 295.324C171.147 299.483 173.63 306.181 176.551 306.152C178.535 306.132 179.475 303.017 182.504 297.293C187.318 288.195 188.47 289.399 192.923 281.051C197.929 271.669 200.438 266.965 198.877 261.857C198.211 259.677 197.591 260.001 191.435 251.029C188.551 246.827 187.109 244.725 185.977 242.662C183.304 237.789 180.258 232.237 180.52 225.436C180.768 218.969 183.895 214.283 185.977 211.163C191.492 202.899 195.278 204.418 199.373 197.383C202.536 191.947 204.191 184.315 202.846 177.204C201.752 171.418 199.489 170.293 200.365 166.868C201.477 162.523 205.751 161.865 214.257 156.041C221.009 151.417 225.461 146.939 228.645 143.736C232.176 140.185 234.968 136.611 240.553 129.463C247.33 120.789 250.773 116.348 253.452 111.253C255.064 108.188 257.596 103.305 259.406 96.4883C260.55 92.18 261.389 87.165 261.887 84.1841C263.459 74.7788 263.244 72.2668 265.36 70.8956C268.895 68.6044 274.936 72.0912 276.275 72.8642C287.225 79.1846 291.076 93.5416 290.167 94.0274C289.448 94.4116 284.566 86.7541 284.709 86.6449C284.854 86.5344 290.549 93.844 302.074 107.808C305.756 112.269 305.909 112.409 309.02 116.175C325.695 136.354 333.537 147.218 334.323 146.689C335.01 146.228 330.214 137.18 329.858 137.338C329.387 137.548 334.713 154.718 340.277 154.564C342.735 154.496 342.912 151.11 347.719 147.674C351.713 144.819 358.522 142.202 362.107 144.721C363.724 145.857 364.616 147.988 364.588 157.025C364.553 168.241 363.159 172.076 363.1 178.188C362.992 189.315 367.496 188.95 368.557 200.336C370.119 217.086 361.028 224.92 366.076 232.819C369.453 238.103 375.76 237.836 379.472 239.709C390.094 245.068 392.165 273.919 368.061 359.798",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.531 409.078V-10.4038L360.587 -10.4038V409.078H449.531Z",
    fill: "#6C3950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.466 54.5017H137.023V132.629H163.466V54.5017Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.457 198.736H70.916V225.179H157.457V198.736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.861 239.603H76.9258V267.247H159.861V239.603Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.831 285.277H68.5117V303.306H141.831V285.277Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.831 334.557H68.5117V344.173H141.831V334.557Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.859 267.248H141.83V344.173H159.859V267.248Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82 156.668H79.3281V179.505H135.82V156.668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.465 148.254H135.82V162.678H163.465V148.254Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.993 110.993H31.25V120.609H118.993V110.993Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.993 79.7427H67.3086V98.9739H118.993V79.7427Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.014 60.5115H100.965V73.733H131.014V60.5115Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9145 36.4724H31.25V48.492H70.9145V36.4724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.983 37.6743H85.3379V54.5017H112.983V37.6743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.821 22.0488H86.541V34.0684H135.821V22.0488Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.133 48.4919H189.908V61.7134H328.133V48.4919Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.384 49.6938H338.951V73.7329H359.384V49.6938Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.332 78.5408H189.908V120.609H204.332V78.5408Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.563 98.9739H204.332V114.599H223.563V98.9739Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.036 73.7329H246.4V106.186H268.036V73.7329Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.094 78.5408H288.469V102.58H304.094V78.5408Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.961 102.58H330.537V171.091H344.961V102.58Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.537 82.1465H318.518V106.186H330.537V82.1465Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.355 82.1465H330.537V98.9738H341.355V82.1465Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.928 136.235H186.303V180.707H201.928V136.235Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.938 141.042H201.928V154.264H207.938V141.042Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.351 135.032H207.938V159.072H216.351V135.032Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.584 124.215H223.564V154.264H235.584V124.215Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.41 110.993H240.391V130.225H252.41V110.993Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.928 198.736H186.303V233.593H201.928V198.736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.535 195.13H193.516V203.544H205.535V195.13Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 222.775H213.947V233.593H246.4V222.775Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.391 233.593H216.352V239.603H240.391V233.593Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.313 234.795H186.303V297.296H192.313V234.795Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.524 254.026H192.312V287.681H199.524V254.026Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.392 209.554H211.545V219.169H240.392V209.554Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.382 179.505H205.535V191.524H234.382V179.505Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.834 159.072H252.41V174.697H266.834V159.072Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.065 160.274H272.844V180.707H286.065V160.274Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.035 179.505H243.996V191.524H268.035V179.505Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.006 191.524H243.996V203.544H250.006V191.524Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42 203.544H243.996V210.756H258.42V203.544Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.921 124.215H310.104V138.639H320.921V124.215Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.528 129.023H320.922V138.638H324.528V129.023Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.094 25.6548H280.055V40.0782H304.094V25.6548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.527 25.6548H310.104V40.0782H324.527V25.6548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.402 22.0488H181.496V37.6742H246.402V22.0488Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.439 24.4529H250.006V42.4822H270.439V24.4529Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.465 25.6548H147.84V46.088H163.465V25.6548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83 25.6548H135.82V46.088H141.83V25.6548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.869 25.6548H163.465V37.6743H165.869V25.6548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.84 25.6548H141.83V40.0782H147.84V25.6548Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9157 60.5115H44.4727V76.1369H70.9157V60.5115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2891 78.5408H31.25V94.1662H55.2891V78.5408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8852 222.775H43.2695V261.238H52.8852V222.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3004 233.593H52.8867V254.026H61.3004V233.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5008 273.257H31.25V281.671H62.5008V273.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5008 263.642H55.2891V273.257H62.5008V263.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2906 287.681H40.8672V297.296H55.2906V287.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 305.71H38.4629V317.73H50.4824V305.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2902 305.71H50.4824V314.124H55.2902V305.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5008 305.71H55.2891V323.739H62.5008V305.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5512 305.71H70.916V322.537H92.5512V305.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9449 303.306H80.5312V305.71H88.9449V303.306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2902 189.121H44.4727V219.169H55.2902V189.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4715 198.736H31.25V209.554H44.4715V198.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4828 168.687H40.8672V189.12H50.4828V168.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4715 185.515H31.25V192.726H44.4715V185.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4715 165.082H31.25V173.495H44.4715V165.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4617 144.648H31.25V162.678H38.4617V144.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9157 147.052H44.4727V162.678H70.9157V147.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3293 174.697H56.4922V186.717H79.3293V174.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3281 159.072H67.3086V168.687H79.3281V159.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.022 100.176H121.396V129.023H137.022V100.176Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.761 117.135L285.783 107.733L259.833 140.797L271.811 150.198L297.761 117.135Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.211 147.672L315.797 140.283L294.476 167.448L303.89 174.837L325.211 147.672Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.60586,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.492 344.173H-9.61523V412.684H425.492V344.173Z",
    fill: "#6C3950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_3920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 352.173,
    fill: "white",
    transform: "translate(0 0.413574)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.37ab111fbd2b51c4a1f9bffd985ae154.svg";
export { ForwardRef as ReactComponent };